import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const validateSearch = z.object({
  email: z.string().email()
});

export const Route = createFileRoute('/_auth/auth/register_/confirmation')({
  validateSearch
});
